import { useMemo } from 'react';
import { FlowMappingRow } from '../FlowMappingRow';
import { MappingColumn } from '../MappingColumn';
import {
  getDataDescriptions,
  getFlowFilter,
  getFlowPanelPosition,
  getFlowSearch,
  getFlowTitle,
  useMappingEditorStore,
  MappingPanelPosition,
  MappingPanelType,
} from '../MappingEditorStore';

// import './FlowMappingColumn.less';
import { ValidationIssue } from '@decisions/server/DecisionsFramework';
import { isConstantDataDescription } from './../utils/DataDescriptionUtils';

export interface IFlowMappingColumnProps {
  validationIssues?: Map<string, ValidationIssue[]>;
  className?: string;
}

/**
 * Renders flow data side of mapping editor
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function FlowMappingColumn({ className, validationIssues }: IFlowMappingColumnProps) {
  const filter = useMappingEditorStore(getFlowFilter);
  const search = useMappingEditorStore(getFlowSearch);
  const title = useMappingEditorStore(getFlowTitle);
  const position = useMappingEditorStore(getFlowPanelPosition);
  const flowData = useMappingEditorStore(getDataDescriptions);
  const data = useMemo(() => Array.from(flowData.values()).filter(entry=> !entry.filtered), [flowData]);

  return (
    <MappingColumn
      className={className}
      position={position}
      title={title}
      filter={filter}
      search={search}
      side={MappingPanelType.FLOW}
    >
      {data.map(desc => (
        <FlowMappingRow
          key={desc.Name}
          dataDescriptionNode={desc}
          path={[desc.Name]}
          validationIssues={validationIssues}
          isForInput={position === MappingPanelPosition.LEFT}
          isConstantData={isConstantDataDescription(desc)}
        />
      ))}
    </MappingColumn>
  );
}
